import React from "react"

export interface LoadScriptProps extends React.HTMLProps<HTMLDivElement> {
  loadHandler: () => void
}

export class LoadScript extends React.Component<LoadScriptProps> {
  scriptAdded: boolean
  scriptContainer: React.RefObject<HTMLDivElement>

  constructor( props: LoadScriptProps ) {
    super( props )
    this.scriptContainer = React.createRef()
    this.scriptAdded = false
  }

  componentDidMount() {
    if( ! this.scriptContainer || ! this.scriptContainer.current ) {
      console.warn( "The script container element is missing" )
      return
    }

    if( this.scriptAdded ) {
      console.warn( "The script was already added and cannot be updated" )
      return
    }

    const { loadHandler } = this.props


    if( loadHandler ) {
      loadHandler()
    }

    this.scriptAdded = true
  }

  render() {
    return (
      <div ref={ this.scriptContainer } { ...this.props as any }/>
    )
  }
}
